// **********************************************************
//  Play video
// **********************************************************
/* eslint-disable */
$(function () {
  $('.mod-video__poster').on('click', function () {
    var parentVideoEle = $(this).parents('.mod-video');
    parentVideoEle.addClass('is-playing');
    parentVideoEle.find('video')[0].play();
  });
});
/* eslint-enable */
